import Section from "@/components/layout/Section";
import Container from "@/components/layout/Container";

export default function TermsOfService() {
  return (
  <>
      <Seo
        title="Terms of Service | Zenia Stays"
        description="Review the Zenia Stays terms of service, platform usage guidelines, limitations, and compliance policies."
        canonical="https://zeniastays.com/terms"
      /> 
    <Section background="bg-bg-surface" padding="lg">
      <Container>
        <div className="max-w-[900px] mx-auto">

          <h1 className="text-display font-extrabold text-text-primary">
            Terms of Service
          </h1>

          <p className="mt-3 text-small text-text-muted">
            Effective Date: 15-04-2026
          </p>

          <div className="mt-8 space-y-8 text-body text-text-muted leading-relaxed">

            <p>
              These Terms of Service govern your use of Zenia Stays. By accessing or using our services,
              you agree to be bound by these terms. If you do not agree, you must discontinue use immediately.
            </p>

            <h2 className="text-title font-semibold text-text-primary">1. Services Overview</h2>
            <p>
              Zenia Stays provides property analysis, revenue estimation tools, listing optimisation,
              interior design consultation, and property management services. We also assist with listing
              setup, pricing strategy, and operational management.
            </p>

            <h2 className="text-title font-semibold text-text-primary">2. No Guaranteed Results</h2>
            <p>
              Zenia Stays does not guarantee revenue, occupancy, bookings, or financial outcomes. All projections,
              insights, and recommendations are indicative and based on available data, trends, and assumptions.
              Actual performance may vary significantly due to market conditions, competition, seasonality,
              property quality, and external factors.
            </p>

            <h2 className="text-title font-semibold text-text-primary">3. Third-Party Platforms</h2>
            <p>
              Our services involve integration and interaction with third-party platforms including Airbnb,
              VRBO, Booking.com, and tools such as Hospitable. Zenia Stays is not affiliated with or endorsed
              by these platforms. You are responsible for complying with their respective terms and policies.
            </p>

            <h2 className="text-title font-semibold text-text-primary">4. User Responsibilities</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Provide accurate and complete property information</li>
              <li>Ensure legal ownership or authorization of property</li>
              <li>Comply with local laws, taxes, and rental regulations</li>
              <li>Maintain property standards required for short-term rentals</li>
            </ul>

            <h2 className="text-title font-semibold text-text-primary">5. Data & Platform Usage</h2>
            <p>
              Users agree not to misuse, copy, reverse engineer, or exploit any part of the Zenia Stays platform,
              including analytics tools, pricing logic, or system architecture.
            </p>

            <h2 className="text-title font-semibold text-text-primary">6. Payments & Fees</h2>
            <p>
              Any service fees, commissions, or charges will be communicated clearly. Payments once made
              are non-refundable unless explicitly agreed in writing.
            </p>

            <h2 className="text-title font-semibold text-text-primary">7. Technology & Infrastructure</h2>
            <p>
              Zenia Stays uses third-party infrastructure and services including cloud databases such as Firebase.
              While we implement best practices, we do not guarantee uninterrupted availability or error-free systems.
            </p>

            <h2 className="text-title font-semibold text-text-primary">8. Limitation of Liability</h2>
            <p>
              Zenia Stays shall not be liable for any indirect, incidental, or consequential damages including
              loss of revenue, business opportunities, or data.
            </p>

            <h2 className="text-title font-semibold text-text-primary">9. Termination</h2>
            <p>
              We reserve the right to suspend or terminate access to services in case of misuse, fraud,
              or violation of these Terms.
            </p>

            <h2 className="text-title font-semibold text-text-primary">10. Compliance</h2>
            <p>
              Users are solely responsible for complying with all applicable local laws, zoning regulations,
              licensing requirements, and tax obligations related to short-term rentals.
            </p>

            <h2 className="text-title font-semibold text-text-primary">11. Changes to Terms</h2>
            <p>
              We may update these Terms periodically. Continued use of the platform constitutes acceptance
              of revised Terms.
            </p>

            <h2 className="text-title font-semibold text-text-primary">12. Contact</h2>
            <p>
              Support: hello@zeniastays.com <br />
              Escalations: operations@zeniastay.com
            </p>

          </div>
        </div>
      </Container>
    </Section>
  </>  
  );
}